import { useState } from "react";
import Box from "@mui/material/Box";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import DiaCalendarioList from "./DiaCalendarioList";
import DiaCalendarioSerie from "./DiaCalendarioSerie";

const DIAS = "dias";
const SERIES = "series";

/** Aba de Dias Letivos Extras ou Dias Não Letivos (conforme `config`). */
const DiaCalendarioMenu = ({ config }) => {
  const [visao, setVisao] = useState(DIAS);

  return (
    <Box>
      <ToggleButtonGroup
        size="small"
        exclusive
        value={visao}
        onChange={(event, value) => value && setVisao(value)}
        sx={{ mb: 2 }}
      >
        <ToggleButton value={DIAS}>{config.plural}</ToggleButton>
        <ToggleButton value={SERIES}>Vincular às Séries</ToggleButton>
      </ToggleButtonGroup>
      {visao === DIAS ? <DiaCalendarioList config={config} /> : <DiaCalendarioSerie config={config} />}
    </Box>
  );
};

export default DiaCalendarioMenu;
